import { useState } from "react";
import { getData } from "@/lib/utils";
import api from "@/store/api";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

const useHelp = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendQuestion = async (
    question: string,
    attachment: File | null = null
  ) => {
    try {
      setIsLoading(true);
      setError(null);

      const Token = getData("tokens")?.accessToken;
      if (!Token) {
        throw new Error(t("help.errors.missingToken"));
      }

      const formData = new FormData();
      formData.append("question", question);
      if (attachment) {
        formData.append("attachment", attachment, attachment.name);
      }

      const response = await api.post("/web/help/questions", formData, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (err: any) {
      console.error(err);
      setError(err.response?.data?.message || t("help.errors.failedToSend"));
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { sendQuestion, isLoading, error };
};

export default useHelp;
